/**
 * Runtime-safe environment resolution used by shared/server-compiled modules.
 *
 * Priority:
 * 1) process.env (Node/runtime)
 * 2) window.__ENV__ (browser runtime injection)
 */
export function getEnvVar(key: string): string | undefined {
  if (typeof process !== "undefined" && process.env?.[key]) {
    return process.env[key];
  }

  if (typeof window !== "undefined") {
    const browserEnv = (window as typeof window & {
      __ENV__?: Record<string, string | undefined>;
    }).__ENV__;

    if (browserEnv?.[key]) {
      return browserEnv[key];
    }
  }

  return undefined;
}
